"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseIcon = void 0;
const react_1 = __importDefault(require("react"));
const components_core_1 = require("@volkswagen-onehub/components-core");
const CloseIconWrapper = components_core_1.styled.div `
  ${({ size }) => `
  height: ${size}px;
  width: ${size}px;
  .icon-container {
    position: relative;
    padding-bottom: 100%;
    height: ${size}px;
    width: ${size}px;
    svg {
      position: absolute;
      top: 0;
      left: 0;
      height: ${size}px;
      width: ${size}px;
    }
  }
  `}
`;
const CloseIcon = ({ iconSize = '24' }) => (react_1.default.createElement(CloseIconWrapper, { size: iconSize },
    react_1.default.createElement("div", { className: "icon-container" },
        react_1.default.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", role: "img", preserveAspectRatio: "none", "aria-labelledby": "closeIconTitle" },
            react_1.default.createElement("title", { id: "closeIconTitle" }, "Close Icon"),
            react_1.default.createElement("path", { d: "M21.474 3.467l-.942-.941L12 11.059 3.466 2.526l-.94.941L11.059 12l-8.533 8.532.94.942L12 12.941l8.532 8.533.942-.942L12.941 12z" })))));
exports.CloseIcon = CloseIcon;
